import React from 'react'
import PageHeader from '../layout/PageHeader'
import SectionHeader from '../utilis/SectionHeader'
import AboutSection from '../element/homeComp/AboutSection';
import ExchangeSection from '../element/homeComp/ExchangeSection';
import TestmonialSection from '../element/homeComp/TestmonialSection';
import AppSection from '../element/homeComp/AppSection';
import "swiper/css";
import {  Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const About = () => {
  const companyImg = [
    "/image/company-section/partner-1.png",
    "/image/company-section/partner-2.png",
    "/image/company-section/partner-3.png",
    "/image/company-section/partner-4.png",
    "/image/company-section/partner-5.png",
    "/image/company-section/partner-6.png",
    "/image/company-section/partner-1.png",
    "/image/company-section/partner-2.png",
    "/image/company-section/partner-3.png",
    "/image/company-section/partner-4.png",
    "/image/company-section/partner-5.png",
    "/image/company-section/partner-6.png",
  ];

  return (
    <div className='about_page '>
      <PageHeader title='About Us' crumb='About' />
      <div className="container px-sm-2 px-4 section-padding">
         {/* HEADING SECTION */}
         <div className="row padding-bottom">
          <div className="col-lg-6 col-sm-10 mx-auto" data-aos="zoom-in">
            <SectionHeader
              subTitle=""
              title="Used By 100K+ Businesses Of All Shapes & Sizes"
            />
          </div>
        </div>
        {/* CONTENT SECTION */}
        <div className="row">
        <Swiper
          slidesPerView={6}
          spaceBetween={20}
          navigation={true}
          breakpoints={{
            320: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            572: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
          }}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          modules={[ Autoplay]}
          className="mySwiper"
        >
          {companyImg.map((element, index) => {
            return (
              <SwiperSlide key={index} className="my-5" data-aos='zoom-in' >
                <div className="company_img">
                  <img src={element} className="img-fluid" alt="" />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        </div>
      </div>

          {/* ABOUT SECTION */}
          <AboutSection/>
          <ExchangeSection/>  
          <AppSection/>
          <TestmonialSection/>
    </div>
  )
}

export default About